export function setLocationHash(curLoc) {
    history.pushState(null, null, curLoc);
    location.hash = curLoc;
}
